import { FragmentParagraphLogoFragment } from '@/utils/drupal-api/__generated__/graphql';
import clsx from 'clsx';

import { ImageSrcSetSize } from '@/utils/image';

import DrupalImage from '@/components/ui/drupal-image';

import styles from './logos.module.scss';
import paragraphStyles from './paragraph.module.scss';

const logoSrcsetSizes: ImageSrcSetSize[] = [
  { viewport: 380, image: 75 },
  { viewport: 768, image: 120 },
  { viewport: 1280, image: 170 },
];

export type LogosProps = {
  data: FragmentParagraphLogoFragment;
  className?: string;
  id?: string;
};

export const Logos: React.FC<LogosProps> = ({ data, className, id }) => {
  const logosCount = data.media.length;

  return (
    <section
      className={clsx(
        paragraphStyles.paragraph,
        styles.paragraphLogos,
        className,
        'paragraph',
        'paragraph-logos'
      )}
      id={id}
      style={{ backgroundColor: data.bgColor ? `#${data.bgColor}` : '' }}
    >
      <div
        className={clsx(
          'mx-auto flex flex-wrap items-center justify-center gap-6 px-4',
          logosCount < 4 && 'max-w-screen-lg',
          logosCount === 4 && 'grid max-w-screen-lg grid-cols-2 sm:grid-cols-4',
          logosCount === 5 && 'max-w-screen-xl md:grid md:grid-cols-5',
          logosCount === 6 &&
            'grid max-w-screen-2xl grid-cols-3 md:grid-cols-6',
          logosCount > 6 && 'max-w-screen-2xl'
        )}
      >
        {data.media.map(
          (media) =>
            media.__typename === 'MediaImage' && (
              <DrupalImage
                image={media.mediaImage}
                key={media.uuid}
                srcsetSizes={logoSrcsetSizes}
                className="mx-auto h-[64px] w-[120px] object-contain lg:h-[75px] lg:w-[145px] xl:h-[90px] xl:w-[170px]"
              />
            )
        )}
      </div>
    </section>
  );
};
